import { friendlyFormatIBAN } from 'ibantools';
import type { FC } from 'react';

export interface ContactOptionProps {
  data: { name: string; iban: string };
  selectOption: (option: any) => void;
}

const ContactOption: FC<ContactOptionProps> = ({ data, selectOption }) => (
  <li
    key={data.name}
    onClick={() => selectOption(data)}
    className="cursor-pointer flex flex-col list-none hover:bg-gray-50 border-b border-b-primary-100 p-4 h-20"
  >
    <span className="text-sm text-purple-dark font-semibold font-assistant truncate">
      {data.name}
    </span>

    <div className="flex items-center gap-6">
      <span className="mt-2 flex items-center text-sm text-gray-500">
        {friendlyFormatIBAN(data.iban)}
      </span>
    </div>
  </li>
);

export default ContactOption;
